<template>
	<div class="access-denied">
		<h1>
			Access Denied
			<font-awesome-icon class="icon" :icon="['fal', 'exclamation-triangle']" />
		</h1>
		<p data-test="access-denied-item">You do not have access to {{ item }}. Please contact your admin.</p>
	</div>
</template>

<script>
export default {
	name: 'AccessDenied',
	props: {
		item: String,
	},
};
</script>

<style lang="scss">
.access-denied {
	@include flex-center;
	flex-direction: column;

	.icon {
		@include rem('font-size', 36px);
		color: $b360-color--blue;
	}
}
</style>
